
<div class="section-liens d-block d-md-flex">
  <EditableArea
    class="row no-gutters h-100 d-block w-100 w-md-50"
    :content="content.sectionLiens"
    :parentTemplateId="metadata['mgnl:template']"
  />
  <div class="row no-gutters h-100 d-block w-100 w-md-50">
    <ListeLiens
      v-for="collection in collectionsAuto"
      :key="collection.name"
      :content="getContentCollection(collection)"
      :isListeAuto="true"
    />
  </div>
</div>
